import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';

import { SolicitarRepasseAliases as Aliases, FragmentNames } from '../../codegen/constants';
import BaseController from '../BaseController';

interface Data {
  nrSeqRepasse: number;
  nrSeqCongenere: number;
  dtRepasse: string;
}
interface LocalAtendimento {
  cdCgc: string;
  cdCongenere: string;
  dsCongenere: string;
  nrSeqCongenere: number;
}

@Controller({ fragment: FragmentNames.SOLICITAR_REPASSE })
class SolicitacaoRepasseController extends BaseController {

  @Inject(Aliases.FORM_SOLICITAR_REPASSE)
  private repasseForm: FormAPI;
  @Inject(Aliases.TOAST_NOTIFICATION)
  private toastForm: ToastNotificationAPI;
  @Inject(Aliases.FORM_SOLICITAR_REPASSE)
  private formSolicRepasse: FormAPI;

  @OnMount(Aliases.FORM_SOLICITAR_REPASSE)
  onMount(event: MountEvent): void {
    const apiForm = event.target as unknown as FormAPI;
    this.fetchForm(apiForm);
  }

  @OnBeforeSubmit(Aliases.FORM_SOLICITAR_REPASSE)
  onBeforeSubmit(event: AbortableSubmitEvent): void {
    const { nrSeqBeneficiario, nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const nrSeqRepasse = this.context.get('nrSeqRepasse');
    const body = { nrSeqBeneficiario, nrSeqRepasse, ...event.record };

    HttpService.post(Endpoint.POST.SOLIC_REPASSE, { nrSeqContrato }, { body })
      .then(() => {
        const mensagem = msg('stipuplator.alteracao.solicitada');
        ToastServiceStipulator.success(mensagem);
        this.fetchForm(this.formSolicRepasse);
      })
      .catch(response => {
        const mensagem = response.body as string;
        this.toastForm.setMessage(mensagem);
        this.toastForm.setVisible(true);
        event.abort();
      });
  }

  @OnCancel(Aliases.FORM_SOLICITAR_REPASSE)
  onCancelForm(): void {
    const { solicAberta } = this.context.getBulkData();
    if (!solicAberta) {
      const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
      HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
    }
  }

  @OnClose(Aliases.TOAST_NOTIFICATION)
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

  private fetchForm(apiForm: FormAPI): void {
    const { nrSeqBeneficiario, nrSeqContrato } = this.historyService.getCurrentRouteParams();

    void HttpService.get<Record<string, Value>>(Endpoint.GET.SOLIC_REPASSE_ABERTA, { nrSeqBeneficiario, nrSeqContrato }).then(response => {
      const { body: solicAberta } = response;
      if (solicAberta) {
        this.context.set({ solicAberta });
        this.repasseForm.setEditing(false);
        const { nrSeqCongenere, dtRepasse, nrSeqRepasse } = solicAberta as unknown as Data;

        void HttpService.get<LocalAtendimento>(Endpoint.GET.LOCAL_ATENDIMENTO, { nrSeqCongenere, nrSeqContrato })
          .then(dados => {
            const localAtendimento = dados.body;
            const data = { localAtendimento, dtRepasse };
            apiForm.setData(data);
          });
        this.context.set({ nrSeqRepasse });
      }

    });
  }
}
export default SolicitacaoRepasseController;
